import FabricAnalyticsListeners, {
  type AnalyticsWebClient
} from '@atlaskit/analytics-listeners';
import { FlagsProvider } from '@atlaskit/flag';
import { ConversationAssistantBlankObjectExperience } from '@atlassian/conversation-assistant-blank-object-experience/conversation-assistant-blank-object-experience';
import { useAnalytics } from '@databases/analytics';
import { getCloudId } from '@databases/database-state';
import React from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';

import { useDatabaseSmartPrompts } from '../blank-object-experience-smart-prompts/useDatabaseSmartPrompts';

import { useDatabaseBlankObjectSubmit } from './useDatabaseBlankObjectSubmit';

interface DatabaseBlankObjectExperienceProps {
  contentId: string;
}

export const DatabaseBlankObjectExperience = ({
  contentId
}: DatabaseBlankObjectExperienceProps) => {
  const { locale } = useIntl();
  const siteId = getCloudId() ?? '';

  const analyticsClient = useAnalytics();
  const analyticsWebClient = analyticsClient?.client as AnalyticsWebClient | undefined;
  const handleSubmit = useDatabaseBlankObjectSubmit({ contentId });
  const { smartPrompts } = useDatabaseSmartPrompts();

  return (
    <IntlProvider locale={locale}>
      <FabricAnalyticsListeners client={analyticsWebClient}>
        <FlagsProvider>
          <ConversationAssistantBlankObjectExperience
            siteId={siteId}
            promptDraftAndModeKey={contentId}
            contentType="database"
            smartPrompts={smartPrompts}
            smartPromptsPosition="above"
            onSubmit={handleSubmit}
            shouldExpandWidth
            shouldRenderQuickActionsInPortal={false}
          />
        </FlagsProvider>
      </FabricAnalyticsListeners>
    </IntlProvider>
  );
};
